import type { AuditLogActor } from '@src/models/interfaces/AuditLog/AuditLogInterface';

/**
 * USER_ACTIVITY rows must attribute a real profile.
 * Missing actors and UID-as-name fallbacks are treated as invalid (hidden in the UI).
 */
export const isValidAuditLogActor = (
  user?: AuditLogActor | null,
): boolean => {
  if (!user) {
    return false;
  }

  const id = typeof user.id === 'string' ? user.id.trim() : '';
  const name = typeof user.name === 'string' ? user.name.trim() : '';
  if (!id || !name) {
    return false;
  }

  if (name === id) {
    return false;
  }

  return true;
};
